import React from 'react';
import styles from './AwardsMemberships.module.css'; // CSS Modules
function AwardsMemberships() {
  
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "MedicalOrganization",
    name: "Krisara Gastro and Liver Clinic",
    url: "https://krisaragastro.com/",
    logo: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    image: "https://i.ibb.co/HDcnBZt3/Rectangle-76.png",
    telephone: "+91 7569541532",
    email: "gastro@krisara.com",
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "3rd Floor, Fairmount Square, Pet Basheerabad, Quthbullapur, Kompally",
      addressLocality: "Hyderabad",
      addressRegion: "Telangana",
      postalCode: "500014",
      addressCountry: "IN",
    },
    sameAs: [
      "https://www.facebook.com/krisaragastro",
      "https://www.instagram.com/krisaragastro",
    ],
  };

  return (
    <section className={styles.amSection}>
      {/* Awards & Recognition */}
      <h2 className={styles.amTitle}>Awards & Recognition</h2>
      <div className={styles.amCardsRow}>
        <img
          src="https://i.ibb.co/gbNs9TJJ/Group-129.png" // e.g. 'images/award-best-oral.png'
          alt="Best Oral Paper Award APICON 2020 in Krisara Gastro"
          className={styles.amCardImg}
        />
        <img
          src="https://i.ibb.co/d0DdkyZn/Group-130.png" // e.g. 'images/award-eus-summit.png'
          alt="Best Oral Presentation EUS Summit 2024- Krisara Gastro"
          className={styles.amCardImg}
        />
        <img
          src="https://i.ibb.co/MqS4Nqp/Group-131.png" // e.g. 'images/award-esge-days.png'
          alt="Poster Presentation ESGE Days 2024- Krisara Gastro"
          className={styles.amCardImg}
        />
      </div>
      <h3 className={styles.amSubtitle}>Professional Memberships</h3>
      <div className={styles.amMembershipsRow}>
        <div className={styles.amMembership}>
          <img
            src="https://i.ibb.co/H3H34LN/image-18-2.png"
            alt="Indian Society of Gastroenterology - krisara gastro"
            className={styles.amMembershipLogo}
          />
        </div>
        <div className={styles.amMembership}>
          <img
            src="https://i.ibb.co/361RVy0/image-17-1.png"
            alt="Society of Gastrointestinal Endoscopy India- krisara gastro"
            className={styles.amMembershipLogo}
          />
        </div>
        <div className={styles.amMembership}>
          <img
            src="https://i.ibb.co/ZRwQ52Lm/image-16-2.png"
            alt="World Endoscopy Organization - krisara gastro"
            className={styles.amMembershipLogo}
          />
        </div>
      </div>
    </section>    
  );
}
export default AwardsMemberships;